module.exports = __webpack_public_path__ + "static/x4d-b20ed1e6eab7c59271af990b21a55204.png";